import 'antd/dist/reset.css';
import React, { useState, useEffect } from 'react';
import { Table, Button, Input,  DatePicker, Row, Col, Form, Tooltip, Divider, Select } from 'antd';
import {CloseOutlined, SearchOutlined} from '@ant-design/icons';
import "dayjs/locale/es";
import Reproductor from './Reproductor';
import { ServicesAudio } from '../services/ServicesAudio';




const formStyle = {
    maxWidth: 'none',
  };

const options_programas = [
        { value: 'DE LA NOCHE AL DIA', label: 'DE LA NOCHE AL DIA' },
        { value: 'EL ANALISIS INTERNACIONAL', label: 'EL ANALISIS INTERNACIONAL' },
        { value: 'EL DEPORTIVO TIEMPO EXTRA', label: 'EL DEPORTIVO TIEMPO EXTRA' },
        { value: 'LA ALPISPA', label: 'LA ALPISPA'},
      ];

const options_categorias = [
        { value: 'Deporte', label: 'Deporte' },
        { value: 'Actualidad', label: 'Actualidad' },
        { value: 'Noticias', label: 'Noticias' },
        { value: 'Actualidad internacional', label: 'Actualidad internacional'},
        { value: 'Historia de Canarias', label: 'Historia de Canarias'},
        { value: 'Música', label: 'Música'},
      ];

const options_protagonistas = [
        {
          value: "Estíbaliz Pérez",
          label: "Estíbaliz Pérez"
        },
        {
          value: "Rita Hernández",
          label: "Rita Hernández"
        },
        {
          value: "Lara Carrascosa",
          label: "Lara Carrascosa"
        },
        {
          value: "Jose Luis",
          label: "Jose Luis"
        },
        {
          value: "Jorge Marichal",
          label: "Jorge Marichal"
        },
        {
          value: "Rubén Sánchez",
          label: "Rubén Sánchez"
        },
        {
          value: "Matilde Asian",
          label: "Matilde Asian"
        },
        {
          value: "Javier Granados",
          label: "Javier Granados"
        },
        {
          value: "Raquel Quiñones",
          label: "Raquel Quiñones"
        },
        {
          value: "Roberto Mancilla",
          label: "Roberto Mancilla"
        },
        {
          value: "Carlos Guillermo Dóminguez",
          label: "Carlos Guillermo Dóminguez"
        },
        {
          value: "Manu Fuster",
          label: "Manu Fuster"
        },
        {
          value: "Antonio Morales",
          label: "Antonio Morales"
        },
        {
          value: "Antonio Porro",
          label: "Antonio Porro"
        },
        {
          value: "Eugenio González",
          label: "Eugenio González"
        },
        {
          value: "Mercedes Martín",
          label: "Mercedes Martín"
        },
        {
          value: "Verónica Pérez",
          label: "Verónica Pérez"
        },
      ];



const highlightText = (text, search, protagonistas = []) => {

  if (!text) return text;

  const palabras = [];

  if (search) palabras.push(search);
  if (protagonistas?.length) palabras.push(...protagonistas);

  if (!palabras.length) return text;

  const regex = new RegExp(`(${palabras.join("|")})`, "gi");

  const parts = text.split(regex);

  return parts.map((part, i) => {

    const match = palabras.some(p =>
      part.toLowerCase() === p.toLowerCase()
    );

    return match ? (
      <span
        key={i}
        style={{
          background: "yellow",
          padding: "2px 4px",
          borderRadius: 3,
          fontWeight: 500
        }}
      >
        {part}
      </span>
    ) : part;

  });
};

/**
 * Component Hemeroteca
 * @returns 
 */
export const Hemeroteca = () => {

  ////////
  // Hooks
  ////////
   const [datos, setDatos] = useState([]);
   const [searchText, setSearchText] = useState("");
   const [selectedProtagonistas, setSelectedProtagonistas] = useState([]);

   const columns = [
  {
    title: 'Fecha',
    dataIndex: 'fecha',
    key: 'fecha',
    width: 120,
  },
  {
    title: 'Programa',
    dataIndex: 'programa',
    key: 'programa',
    width: 200,
  },
  {
    title: 'Categorías',
    dataIndex: 'categorias',
    key: 'categorias',
    width: 400,
    render: (categorias) => categorias?.join(", "),
  },
  {
    title: 'Protagonistas',
    dataIndex: 'protagonistas',
    key: 'protagonistas',
    width: 400,
    render: (protagonistas) => protagonistas?.join(", "),
  },
  {
    title: 'Play-Detalles',
    key: 'play',
    dataIndex: 'play',
    render:(_,record)=>(
      <div>
        <Reproductor
          audio={record.audio}
          transcript={record.transcripcion}
          start={record.startOffset}
        />
        {record.frase && (
          <p>
            "..."{highlightText(
              record.frase,
              searchText,
              selectedProtagonistas
            )}"..."
          </p>
        )}
      </div>
    )
  },
];

  
//logica y funciones para el modal
 const [form] = Form.useForm();

  const getDatos = async(fecha_inicio, fecha_fin, categorias, programas, protagonistas, texto) => {
    const datos = await ServicesAudio.getDatos(fecha_inicio, fecha_fin, categorias, programas, protagonistas, texto);
    setDatos(datos);
  }

  const handleSearch = () => {

    const form_values = form.getFieldsValue();

    const fecha_inicio = form_values.fecha_inicio
      ? form_values.fecha_inicio.format("DD/MM/YYYY")
      : null;

    const fecha_fin = form_values.fecha_fin
      ? form_values.fecha_fin.format("DD/MM/YYYY")
      : null;

    setSearchText(form_values.texto);
    setSelectedProtagonistas(form_values.protagonistas || []);

    getDatos(
      fecha_inicio,
      fecha_fin,
      form_values.categorias,
      form_values.programas,
      form_values.protagonistas,
      form_values.texto
    );
  };

  const clearFilters = () => {
    form.resetFields();
    getDatos();
  };

  return (
    <>
      <Form name="filters"
        style={formStyle}
        form = {form}
        initialform_values={{ categorias:null, programas:null, protagonistas:null, texto:null }}
      >
        <Row gutter={24} style={{marginBottom:'0px'}}>
          <Col style={{marginTop: '10px', marginBottom:'0px'}} xs={24} lg={4}>
            <Form.Item
              style={{ marginBottom:'10px'}}
              name="fecha_inicio">
                <DatePicker placeholder='Fecha inicio' style={{ width: '100%' }} size='large'/>
            </Form.Item>
          </Col>
          <Col style={{marginTop: '10px', marginBottom:'0px'}} xs={24} lg={4}>
            <Form.Item
            style={{ marginBottom:'10px'}}
              name="fecha_fin">
                <DatePicker placeholder='Fecha fin' style={{ width: '100%' }} size='large'/>
            </Form.Item>
          </Col>
          <Col style={{marginTop: '10px', marginBottom:'0px'}} xs={24} lg={4}>
            <Form.Item 
            style={{ marginBottom:'10px'}}
              name="categorias">
              <Select
                mode="multiple"
                size='large'
                allowClear
                placeholder="Categoria"
                options={options_categorias}
              />
            </Form.Item>
          </Col>
          <Col style={{marginTop: '10px', marginBottom:'0px'}} xs={24} lg={4}>
            <Form.Item 
            style={{ marginBottom:'10px'}}
              name="programas">
              <Select
                mode="multiple"
                size='large'
                allowClear
                placeholder="Programa"
                options={options_programas}
              />
            </Form.Item>
          </Col>
          <Col style={{marginTop: '10px', marginBottom:'0px'}} xs={24} lg={4}>
            <Form.Item 
            style={{ marginBottom:'10px'}}
              name="protagonistas">
              <Select
                mode="multiple"
                size='large'
                allowClear
                placeholder="Protagonistas"
                options={options_protagonistas}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col xs={24} lg={20}>
            <Form.Item 
              initialValue={form.texto}
              name="texto">
              <Input 
                size='large' 
                allowClear 
                placeholder='Texto'
                suffix={<SearchOutlined />}
                onPressEnter={handleSearch}
              />
            </Form.Item>
          </Col>
          <Col xs={3} lg={1}>
            <Form.Item >
              <Tooltip title="Limpiar filtros">
                <Button
                  size='large' 
                  type="text"        
                  outl              
                  onClick={() =>clearFilters()}                    
                  icon={<CloseOutlined/>}>                      
                </Button>
              </Tooltip>
            </Form.Item>
          </Col>
          <Col xs={12} lg={3}>
            <Form.Item >
              <Button 
                size='large'
                type="primary" 
                icon={<SearchOutlined/>}
                onClick={() =>handleSearch()} 
              >
                Filtrar
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>    
      <Divider style={{margin:3}}/>
      <Table columns={columns} dataSource={datos} />
    </>
    
  
)
}